import Vue from "vue";
import VueRouter from "vue-router";
import AuthMiddleware from "@/middleware/auth";
import Login from "@/views/auth/login";
import Logout from "@/views/auth/logout";
import DashboardIndex from "@/views/dashboard";
import UserIndex from "@/views/user/index";
import UserEdit from "@/views/user/edit";
import UserView from "@/views/user/view";
import UserDelete from "@/views/user/delete";
import RequestIndex from "@/views/request";
import ServiceRequestIndex from "@/views/request/service/index";
import ServiceRequestEdit from "@/views/request/service/edit";
import ServiceRequestView from "@/views/request/service/view";
import ServiceRequestDelete from "@/views/request/service/delete";
import LeaveRequestIndex from "@/views/request/leave/index";
import LeaveRequestEdit from "@/views/request/leave/edit";
import LeaveRequestView from "@/views/request/leave/view";
import LeaveRequestDelete from "@/views/request/leave/delete";
import TravelRequestIndex from "@/views/request/travel/index";
import TravelRequestEdit from "@/views/request/travel/edit";
import TravelRequestView from "@/views/request/travel/view";
import TravelRequestDelete from "@/views/request/travel/delete";
import MiscRequestIndex from "@/views/request/misc/index";
import MiscRequestEdit from "@/views/request/misc/edit";
import MiscRequestView from "@/views/request/misc/view";
import MiscRequestDelete from "@/views/request/misc/delete";
import ReportIndex from "@/views/report";
import EngineerReportIndex from "@/views/report/engineer";
import EngineerReport from "@/views/report/engineer/report";
import ServiceReportIndex from "@/views/report/service";
import ServiceReport from "@/views/report/service/report";
import Export from "@/views/export";
import ServiceExport from "@/views/export/service";
import LeaveExport from "@/views/export/leave";
import TravelExport from "@/views/export/travel";
import MiscExport from "@/views/export/misc";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/logout",
    component: Logout,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/dashboard",
    component: DashboardIndex,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/user",
    component: UserIndex,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/user/add/",
    component: UserEdit,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/user/view/:id",
    component: UserView,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/user/edit/:id",
    component: UserEdit,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/user/delete/:id",
    component: UserDelete,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request",
    component: RequestIndex,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/service",
    component: ServiceRequestIndex,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/service/view/:id",
    component: ServiceRequestView,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/service/edit/:id",
    component: ServiceRequestEdit,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/service/add",
    component: ServiceRequestEdit,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/service/delete/:id",
    component: ServiceRequestDelete,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/leave",
    component: LeaveRequestIndex,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/leave/view/:id",
    component: LeaveRequestView,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/leave/edit/:id",
    component: LeaveRequestEdit,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/leave/add",
    component: LeaveRequestEdit,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/leave/delete/:id",
    component: LeaveRequestDelete,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/travel",
    component: TravelRequestIndex,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/travel/view/:id",
    component: TravelRequestView,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/travel/edit/:id",
    component: TravelRequestEdit,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/travel/add",
    component: TravelRequestEdit,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/travel/delete/:id",
    component: TravelRequestDelete,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/misc",
    component: MiscRequestIndex,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/misc/view/:id",
    component: MiscRequestView,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/misc/edit/:id",
    component: MiscRequestEdit,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/misc/add",
    component: MiscRequestEdit,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/request/misc/delete/:id",
    component: MiscRequestDelete,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/report",
    component: ReportIndex,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/report/engineer",
    component: EngineerReportIndex,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/report/engineer/view/:id",
    component: EngineerReport,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/report/service",
    component: ServiceReportIndex,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/report/service/view",
    component: ServiceReport,
    beforeEnter: AuthMiddleware,
  },
  {
    path: "/export",
    component: Export,
  },
  {
    path: "/export/service",
    component: ServiceExport,
  },
  {
    path: "/export/leave",
    component: LeaveExport,
  },
  {
    path: "/export/travel",
    component: TravelExport,
  },
  {
    path: "/export/misc",
    component: MiscExport,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
